import { render, staticRenderFns } from "./ArchiveShare.vue?vue&type=template&id=6ea5c993&scoped=true"
import script from "./ArchiveShare.vue?vue&type=script&lang=js"
export * from "./ArchiveShare.vue?vue&type=script&lang=js"
import style0 from "./ArchiveShare.vue?vue&type=style&index=0&id=6ea5c993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea5c993",
  null
  
)

export default component.exports